import client from "@https/api";
import type {
    IGetDealsResponse,
    ICouponSaveRequest,
    ISavedCouponsResponse,
    ICouponsHistoryResponse,
    IGetDealsRequest
} from "@types";
import gate from "gate/gate";

const PromotionsApi = {
    getDeals: (
        data?: IGetDealsRequest
    ) => {

        return gate.post<IGetDealsResponse, IGetDealsRequest, any>({
            client,
            url: "user/promotion",
            data
        });
    },

    saveCoupon: (id: number, data: ICouponSaveRequest) => {
        console.log("🚀🚀🚀 ~ promotionsApi.ts:25 ~ data:", data)
        return gate.get<any, ICouponSaveRequest, never>({
            client,
            url: `user/promotion/${id}/save`,
            data,
        })
    },

    unsaveCoupon: (id: number, data: ICouponSaveRequest) =>
        gate.get<any, ICouponSaveRequest, never>({
            client,
            url: `user/promotion/${id}/unsave`,
            data,
        }),

    getSavedCoupons: () =>
        gate.get<ISavedCouponsResponse, never, never>({
            client,
            url: "promotion/getSavedCoupons",
        }),

    getCouponsHistory: (cursor?: string) => {
        const url = cursor ? `user/promotion/getCouponsHistory/${cursor}` : "user/promotion/";
        return gate.get<ICouponsHistoryResponse, never, never>({
            client,
            url: url,
        });
    },
};

export default PromotionsApi; 